---
title: Plan, suplimente și facturi
parent: Documentație
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Plan, suplimente, facturi și pagini legale

## Un singur plan cu tot inclus

TOBY oferă un plan complet fără taxă de configurare și fără niveluri ascunse:

- **Facturare lunară sau anuală:** Alegeți facturarea lunară flexibilă (anulabilă lunar în orice moment) sau facturarea anuală cu reducere (plătibilă și prin factură). Consultați [lista de prețuri](/ro/pricing) pentru prețurile actuale.

Fiecare abonament include:

- **Propriul dumneavoastră domeniu** (<DomainTlds />) — inclusiv transferul unui domeniu existent (Domain-Umzug)
- **1 adresă de email** (info@...) cu o **căsuță poștală de 15 GB (Maxi-Postfach)** și adrese de redirecționare nelimitate
- **Până la 15 pagini** — create și întreținute prin chat, voce sau încărcare foto
- **1 limbă suplimentară** (2 limbi în total) cu traducere automată la publicare
- **Newsletter** cu **1.000 de emailuri / lună**
- **Analiză vizitatori** (prietenoasă cu confidențialitatea, fără bannere cookie)
- **Pachet de start prin poștă** (autocolant pentru ușă și suport de masă A5 cu cod QR)
- **Găzduire în UE** cu securitate SSL automată

## Suplimente opționale

Dacă afacerea dumneavoastră crește dincolo de limitele incluse, puteți adăuga oricând module flexibile din **Setări → Abonament** (anulabile lunar, consultați [lista de prețuri](/ro/pricing)):

- **+15 GB spațiu de stocare email** (sau o căsuță poștală suplimentară)
- **+1 limbă suplimentară pentru site**
- **+15 pagini suplimentare**
- **+5.000 de emailuri newsletter / lună**

## Obținerea unei facturi comerciale corecte (site web vs. Google Play)

Dacă conduceți o afacere, practică sau cont de freelancer și aveți nevoie de o **factură comercială corespunzătoare deductibilă fiscal (ordentliche Rechnung)** cu numele companiei dumneavoastră, adresa comercială și TVA afișată separat, vă rugăm să rețineți de unde vă abonați:

- **Abonare pe site (tobysite.com prin Stripe):** Primiți întotdeauna o **factură comercială corespunzătoare cu TVA** de la noi, adresată afacerii dumneavoastră. Puteți descărca toate facturile anterioare și actualiza adresa de facturare a companiei în orice moment din **Setări → Abonament**.
- **Abonare în aplicația Android (Achiziție în aplicație Google Play):** Când vă abonați prin Google Play, Google procesează plata ca comerciant principal și emite doar o chitanță standard de plată Google Play. **Nu putem emite o factură comercială cu TVA (ordentliche Rechnung) pentru abonamentele facturate prin Google Play.**

> **Sfat:** Puteți să vă abonați pe **tobysite.com** în browser pentru a obține facturi comerciale Stripe corespunzătoare și să utilizați în continuare aplicațiile TOBY pentru Android și iOS cu contul dumneavoastră fără costuri suplimentare.

## Adăugarea Imprintului (Impressum) și Politicii de confidențialitate (Datenschutz)

- **Propriul dumneavoastră text legal:** Deoarece cerințele legale depind de structura afacerii, profesia și țara dumneavoastră, **TOBY nu generează consultanță juridică și nu redactează texte legale (Impressum sau Datenschutzerklärung) în mod independent.**
- **Cum să le adăugați:** Pur și simplu inserați textul existent al Imprintului sau Politicii de confidențialitate în chat (sau încărcați-l ca document Word/PDF, sau solicitați TOBY să îl copieze de pe vechiul dumneavoastră site) și spuneți *„Pune asta pe pagina noastră de Imprint."* TOBY va crea paginile și le va lega corespunzător în subsolul site-ului dumneavoastră.
